export default "__VITE_ASSET__bbdeb5f5__"